import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "13.423",
      cy: "3.682",
      r: "2.577",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.5 3.182a.5.5 0 1 0 0 1zm8.969.854a.5.5 0 0 0 0-.708L6.287.146a.5.5 0 0 0-.707.708l2.828 2.828L5.58 6.51a.5.5 0 0 0 .707.708zM.5 3.682v.5h8.615v-1H.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }